import { useState, useEffect } from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import Select from "react-select";
import { FaSearch } from "react-icons/fa";
// router
import { useSearchParams } from "react-router-dom";
// service
import {
  getConfigScheduling,
  getActivitiesByUser,
  existsLoginInEvent,
} from "../../services/scheduling";
// redux
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SchedulingActions from "../../store/actions/scheduling";
// componentes
import ListSaved from "./listSaved";
import ListRooms from "./listRooms";
import ListRoomTimes from "./listRoomTimes";
import Stepper from "../../components/Stepper";
import SectionTabs from "../../components/SectionTabs";
import CardError from "../../components/CardError";
// constantes
import { VIEW, ERROR } from "./constants";

const customStyles = {
  control: (provided) => ({
    ...provided,
    paddingLeft: "30px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    flexDirection: "row-reverse",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    position: "absolute",
    left: 10,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#aaa",
    paddingLeft: "5px",
  }),
};

const CustomDropdownIndicator = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        left: 10,
        display: "flex",
        alignItems: "center",
      }}
    >
      <FaSearch size={14} color="#aaa" />
    </div>
  );
};

const Search = ({ step, options, type, setType, countTypes }) => (
  <>
    {step === VIEW.ROOMS && countTypes > 1 && (
      <div className="sched-filter">
        <Select
          options={[
            {
              options: [
                { label: "TODOS", value: "todos" },
                ...options.sort((a, b) =>
                  a.label > b.label ? 1 : a.label < b.label ? -1 : 0
                ),
              ],
            },
          ]}
          value={type || { label: "TODOS", value: "todos" }}
          isClearable={true}
          onChange={(e) => setType(e)}
          components={{ DropdownIndicator: CustomDropdownIndicator }}
          styles={customStyles}
          noOptionsMessage={() => "Nenhum tipo encontrado"}
        />
      </div>
    )}
  </>
);

// Secoes navegaveis pelas abas do topo. Os horarios de uma sala pertencem a
// Agenda, entao nao formam uma aba propria — o stepper cuida desse nivel.
// Os icones sao os mesmos que o botao de navegacao anterior usava para cada
// destino, para quem ja conhecia a tela nao precisar reaprender.
const SECTION_TABS = [
  { label: "Meus Agendamentos", value: VIEW.SAVED, icon: "bx bx-check-circle" },
  { label: "Agenda", value: VIEW.ROOMS, icon: "bx bx-list-ol" },
];

const PANEL_ID = "sched-panel";

const titles = {
  [VIEW.SAVED]: "Meus Agendamentos",
  [VIEW.ROOMS]: "Agenda",
  [VIEW.ROOM_TIMES]: "Horários da Sala",
};

// Etapas do funil de agendamento, na ordem em que sao percorridas.
// VIEW.SAVED fica de fora: e o destino do fluxo, nao uma etapa.
const FUNNEL_STEPS = [
  { label: "Sala(s)", step: VIEW.ROOMS },
  { label: "Horário(s)", step: VIEW.ROOM_TIMES },
];

function AllScheduling(props) {
  const [searchParams] = useSearchParams();
  // redux
  const { config, user } = useSelector((state) => state.scheduling);
  // pagina atual
  const [step, setStep] = useState(VIEW.LOADING);
  // falha que impede montar a pagina (codigo de ERROR) ou null
  const [error, setError] = useState(null);
  // sala selecionada
  const [roomSelected, setRoomSelected] = useState(null);
  // exibir botão
  const [showBtn, setShowBtn] = useState(true);

  const [options, setOptions] = useState([]);
  const [countTypes, setCountTypes] = useState(0);

  const [type, setType] = useState("");

  // posicao dentro do funil (1-based); 0 quando a tela atual nao faz parte dele
  const funnelStep = FUNNEL_STEPS.findIndex((f) => f.step === step) + 1;

  // os horarios de uma sala continuam sob a aba Agenda
  const activeTab = step === VIEW.SAVED ? VIEW.SAVED : VIEW.ROOMS;

  // Fora da janela de datas (showBtn) o participante ainda consulta o que ja
  // agendou, mas nao pode abrir a Agenda — ela sai do menu em vez de o menu
  // inteiro desaparecer, para a tela nao mudar de forma.
  const visibleTabs = showBtn
    ? SECTION_TABS
    : SECTION_TABS.filter((tab) => tab.value === VIEW.SAVED);

  const tabsVisible = step !== VIEW.LOADING;

  function getConfig(id) {
    getConfigScheduling(id)
      .then((res) => {
        // console.log("config", res)
        if (res.id) {
          props.addConfig(res);

          if (
            (res.limitByDate && new Date() < new Date(res.startDate)) ||
            (res.limitByDate && new Date() > new Date(res.endDate))
          ) {
            setShowBtn(false);
          }

          setStep(VIEW.SAVED);
        } else if (res.message === "NOT_FOUND") {
          setShowBtn(false);
          setError(ERROR.CONFIG_NOT_FOUND);
        }
      })
      .catch((error) => console.log("erro", error));
  }

  function getListSaved(idEvent, idPart) {
    getActivitiesByUser(idEvent, idPart)
      .then((res) => {
        if (res.length > 0) {
          props.addSaved(res);
        } else props.addSaved([]);
      })
      .catch((error) => console.log("erro", error));
  }

  useEffect(() => {
    // resetar o redux
    props.addUser({});
    props.addConfig({});
    props.addSaved([]);

    // pegar parametros

    if (window.location.search) {
      const idEvent = searchParams.get("idEvent");
      const idPart = searchParams.get("idPart");

      if (idEvent && idPart) {
        checkLoginExistsInEvent(idEvent, idPart);
      } else {
        if (!idEvent || !idPart) {
          setError(ERROR.PARAMS_NOT_FOUND);
        }
      }
    } else {
      setError(ERROR.PARAMS_NOT_FOUND);
    }
  }, []);

  async function checkLoginExistsInEvent(idEvent, idPart) {
    const res = await existsLoginInEvent(idEvent, idPart);
    if (res.message !== "LOGIN_FOUND") {
      setError(ERROR.LOGIN_NOT_FOUND);
    } else {
      props.addUser({
        idEvent,
        idPart,
      });

      getConfig(idEvent);
    }
  }

  useEffect(() => {
    if (step === VIEW.SAVED && user) {
      getListSaved(user.idEvent, user.idPart);
    }
  }, [step, user]);

  return (
    <>
      <section
        className="section-scheduling"
        style={{
          "--sched-bg": config.backgroundColor ? config.backgroundColor : "#fff",
          "--sched-btn": config.buttonColor ? config.buttonColor : "#1cbe1c",
        }}
      >
        <Card className="card-scheduling">
          <CardBody>
            {/* exibir essa mensagem apenas para o evento em desse id  */}
            {user?.idEvent &&
              user.idEvent === "c51fbf89-d598-4cf0-bc36-48faf99df29f" && (
                // <div style={{ display: "flex", flexDirection: "column" }}>
                <div>
                  <ul>
                    <li>
                      As{" "}
                      <span style={{ fontWeight: "bold" }}>
                        vagas das atividades
                      </span>{" "}
                      disponíveis no botão{" "}
                      <span style={{ fontWeight: "bold" }}>RESERVE AQUI</span>{" "}
                      são <span style={{ fontWeight: "bold" }}>gratuitas</span>,
                      mas{" "}
                      <span style={{ fontWeight: "bold" }}>
                        sujeitas à lotação do espaço
                      </span>{" "}
                      — por isso, são{" "}
                      <span style={{ fontWeight: "bold" }}>limitadas</span>.
                    </li>

                    <li>
                      Mostre seu{" "}
                      <span style={{ fontWeight: "bold" }}>QR Code</span> na
                      entrada da atividade que escolheu.
                    </li>

                    <li>
                      Chegue até{" "}
                      <span style={{ fontWeight: "bold" }}>15 min antes</span> —
                      depois disso, sua vaga pode ser liberada para{" "}
                      <span style={{ fontWeight: "bold" }}>fila de espera</span>
                      .
                    </li>

                    <li>
                      Não conseguirá ir?{" "}
                      <span style={{ fontWeight: "bold" }}>
                        Cancele pelo app
                      </span>{" "}
                      e libere a vaga para outra pessoa.
                    </li>

                    <li>
                      A programação pode mudar, então{" "}
                      <span style={{ fontWeight: "bold" }}>fique de olho!</span>
                    </li>
                  </ul>
                </div>
              )}

            {error ? (
              <CardError message={error} />
            ) : (
              <>
                {tabsVisible && (
                  <SectionTabs
                    tabs={visibleTabs}
                    active={activeTab}
                    panelId={PANEL_ID}
                    onSelect={(value) => {
                      setStep(value);
                      if (value === VIEW.SAVED) setType({});
                    }}
                  />
                )}

                <div
                  id={PANEL_ID}
                  role="tabpanel"
                  aria-labelledby={`sched-tab-${activeTab}`}
                >
                  <Search
                    step={step}
                    options={options}
                    type={type}
                    setType={setType}
                    countTypes={countTypes}
                  />

                  {funnelStep > 0 && (
                    <Stepper
                      steps={FUNNEL_STEPS}
                      currentStep={funnelStep}
                      onStepClick={(index) =>
                        setStep(FUNNEL_STEPS[index - 1].step)
                      }
                    />
                  )}

                  {/*
                    Nas telas de lista a aba ativa ja nomeia a secao, entao o
                    titulo so repetiria a mesma palavra logo abaixo. Ele aparece
                    quando nao ha abas (fora da janela de datas) e na tela de
                    horarios, onde mostra a sala escolhida — informacao que
                    nenhum outro elemento traz.
                  */}
                  {step === VIEW.ROOM_TIMES ? (
                    <CardTitle className="mt-4">{roomSelected}</CardTitle>
                  ) : (
                    !tabsVisible && (
                      <CardTitle className="mt-4">{titles[step]}</CardTitle>
                    )
                  )}

                  {step === VIEW.SAVED && (
                    <ListSaved getListSaved={getListSaved} />
                  )}
                  {step === VIEW.ROOMS && (
                    <ListRooms
                      setStep={setStep}
                      setRoomSelected={setRoomSelected}
                      setOptions={setOptions}
                      countTypes={countTypes}
                      setCountTypes={setCountTypes}
                      type={type?.value}
                    />
                  )}
                  {step === VIEW.ROOM_TIMES && (
                    <ListRoomTimes
                      roomSelected={roomSelected}
                      setStep={setStep}
                    />
                  )}
                </div>
              </>
            )}
          </CardBody>
        </Card>
      </section>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(SchedulingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AllScheduling);
